/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     RequestCheckResponse.js
//   Details:    RequestCheckResponse.js
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 105066 06/01/20 JC  M01  Added font awesome
//-------------------------------------------------------
*/
import React from 'react';
import PropTypes from 'prop-types';
//M01 import { Glyphicon } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; //M01
import './css/RequestCheckResponse.css';

const RequestCheckResponse = props =>
	<div className="check-response">
		<div className="text-col">
			<h5>{props.site}</h5>
			<span>{props.details}</span>
		</div>
        {props.status === 0
            ? <div className="check-response-over"><FontAwesomeIcon icon="exclamation-circle" /> Over</div> /* M01 */
            : <div className="check-response-ok"><FontAwesomeIcon icon="check" /> OK</div> /* M01 */
		}
	</div>
;

RequestCheckResponse.propTypes = {
	site: PropTypes.string.isRequired,
	details: PropTypes.string.isRequired,
	status: PropTypes.number.isRequired
};

export default RequestCheckResponse;